import BaseModel from './BaseModel'
import {db} from '../utilities'

export default class Rubrics extends BaseModel {
    constructor () {
        super(db.collection('rubrics'))
    }
}